import React from 'react';
import '../../styles/onboardingFlow/slides/slide4.scss';
import bellIcon from '../../assets/onboarding/slides/slide4/BellRinging.svg';
import window1 from '../../assets/onboarding/slides/slide4/window1.png';
import window2 from '../../assets/onboarding/slides/slide4/window2.svg';
import window3 from '../../assets/onboarding/slides/slide4/window3.svg';
import window4 from '../../assets/onboarding/slides/slide4/window4.svg';

const Slide4 = () => {
  return (
    <div className='slide4'>
      <div className='slide4__content'>
        {/* Alert Windows */}
        <div className='slide4__windows'>
          <div className='slide4__window slide4__window--1'>
            <img src={window1} alt='Alert Window 1' />
          </div>
          <div className='slide4__window slide4__window--2'>
            <img src={window2} alt='Alert Window 2' />
          </div>
          <div className='slide4__window slide4__window--3'>
            <img src={window3} alt='Alert Window 3' />
          </div>
          <div className='slide4__window slide4__window--4'>
            <img src={window4} alt='Alert Window 4' />
          </div>
        </div>

        {/* Main Content */}
        <div className='slide4__main'>
          {/* Title with Icon */}
          <div className='slide4__title'>
            <h1>
              Monitoring{' '}
              <img src={bellIcon} alt='Bell' className='slide4__title-icon' />
            </h1>
          </div>

          {/* Subtitle */}
          <h2 className='slide4__subtitle'>Always in Control</h2>

          {/* Description */}
          <p className='slide4__description'>
            TARA keeps an eye on your platform 24/7. It flags unusual trends,
            performance drops, or engagement spikes, helping you fix issues
            before they impact your business.
          </p>

          {/* Progress Bars */}
          <div className='slide4__progress'>
            <div className='slide4__progress-dot'></div>
            <div className='slide4__progress-dot'></div>
            <div className='slide4__progress-dot'></div>
            <div className='slide4__progress-dot slide4__progress-dot--active'></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Slide4;
